import Root from './routes/root';
import AccountLayout from './routes/AccountLayout';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import AppProvider from './main-provider';

//PAGES
import AccountOverview from '@/features/account_overview/pages/AccountOverview';
import Whitelist from '@/features/whitelist/pages/Whitelist';
import Develop from '@/features/develop/pages/Develop';
import AccountSwitches from '@/features/switches/pages/AccountSwitches';
import AccountSwitchDetail from '@/features/switches/pages/AccountSwitchDetail';
import UpdateApiKey from '@/features/develop/pages/UpdateApiKey';
import Dids from '@/features/dids/pages/Dids';
import Did from '@/features/dids/pages/Did';
import DidAutoResponders from '@/features/dids/pages/DidAutoResponders';
import DidForwards from '@/features/dids/pages/DidForwards';
import DidUpdate from '@/features/dids/pages/DidUpdate';
import DidSendManualMessage from '@/features/dids/pages/DidSendManualMessage';
import DidApiKeys from '@/features/dids/pages/DidApiKeys';
import DidConversations from '@/features/dids/pages/DidConversations';
import Messaging from '@/features/messaging/pages/Messaging';
import Sms from '@/features/messaging/pages/Sms';
import Mms from '@/features/messaging/pages/Mms';
import OptOuts from '@/features/messaging/pages/OptOuts';
import LoginPage from '@/features/auth/pages/LoginPage';
import ForgotPasswordPage from '@/features/auth/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/features/auth/pages/ResetPasswordPage';
import PageNotFoundPage from '@/features/404/pages/PageNotFoundPage';
import Tcr from '@/features/tcr/pages/Tcr';
import Brands from '@/features/tcr/pages/Brands';
import Brand from '@/features/tcr/pages/Brand';
import Campaigns from '@/features/tcr/pages/Campaigns';
import Campaign from '@/features/tcr/pages/Campaign';
import Users from '@/features/users/pages/Users';
import UpdateUser from '@/features/users/pages/UpdateUser';
import CreateUser from '@/features/users/pages/CreateUser';
import SubAccounts from '@/features/accounts/pages/SubAccounts';
import SubAccount from '@/features/accounts/pages/SubAccount';
import CreateSubAccount from '@/features/accounts/pages/CreateSubAccount';
import AutoResponders from '@/features/autoResponders/pages/AutoResponders';
import AccountContacts from '@/features/accountSettings/pages/AccountContacts';
import AccountContact from '@/features/accountSettings/pages/AccountContact';
import ManageAccount from '@/features/accountSettings/pages/MangageAccount';
import IpWhitelist from '@/features/accountSettings/pages/IpWhitelist';
import MfaEnforcement from '@/features/accountSettings/pages/MfaEnforcement';
import Settings from '@/features/userSettings/pages/Settings';
import Security from '@/features/userSettings/pages/Security';
import SettingsProfile from '@/features/userSettings/pages/SettingsProfile';
import SettingsAppearance from '@/features/userSettings/pages/SettingsAppearance';
import Support from '@/features/support/pages/Support';
import { ComponentsPage } from '@/features/testing/pages/ComponentsPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <p> error</p>,
  },
  {
    path: '/a/:accountId',
    element: <AccountLayout />,
    children: [
      {
        index: true,
        element: <AccountOverview />,
      },
      {
        path: 'develop',
        element: <Develop />,
      },

      {
        path: 'develop/:apiKeyId',
        element: <UpdateApiKey />,
      },
      {
        path: 'develop/:apiKeyId/numbers',
        element: <UpdateApiKey tab="numbers" />,
      },
      {
        path: 'numbers',
        element: <Dids />,
      },
      {
        path: 'switches',
        element: <AccountSwitches />,
      },
      {
        path: 'switches/:switchId',
        element: <AccountSwitchDetail tab="overview" />,
      },
      {
        path: 'switches/:switchId/forwarding',
        element: <AccountSwitchDetail tab="forwarding" />,
      },
      {
        path: 'switches/:switchId/numbers',
        element: <AccountSwitchDetail tab="numbers" />,
      },
      {
        element: <Did />,
        path: 'numbers/:didId',
      },
      {
        path: 'numbers/:didId/auto-responders',
        element: <DidAutoResponders />,
      },
      {
        path: 'numbers/:didId/forwards',
        element: <DidForwards />,
      },
      {
        path: 'numbers/:didId/update',
        element: <DidUpdate />,
      },
      {
        path: 'numbers/:didId/api-keys',
        element: <DidApiKeys />,
      },
      {
        path: 'numbers/:didId/conversations',
        element: <DidConversations />,
      },
      {
        path: 'numbers/:didId/send-manual-message',
        element: <DidSendManualMessage />,
      },
      {
        path: 'messaging',
        element: <Messaging />,
      },
      {
        path: 'messaging/smses/:smsId',
        element: <Sms />,
      },
      {
        path: 'messaging/mmses/:mmsId',
        element: <Mms />,
      },
      {
        path: 'messaging/opt-outs',
        element: <OptOuts />,
      },
      {
        path: 'tcr',
        element: <Tcr />,
      },
      {
        path: 'tcr/brands',
        element: <Brands />,
      },
      {
        path: 'tcr/brands/:brandId',
        element: <Brand />,
      },
      {
        path: 'tcr/campaigns',
        element: <Campaigns />,
      },
      {
        path: 'tcr/campaigns/:campaignId',
        element: <Campaign />,
      },
      {
        path: 'users',
        element: <Users />,
      },
      {
        path: 'users/create-user',
        element: <CreateUser />,
      },
      {
        path: 'users/:userId',
        element: <UpdateUser />,
      },
      {
        path: 'sub-accounts',
        element: <SubAccounts />,
      },
      {
        path: 'sub-accounts/create-sub-account',
        element: <CreateSubAccount />,
      },
      {
        path: 'sub-accounts/:subAccountId',
        element: <SubAccount />,
      },
      {
        path: 'auto-responders',
        element: <AutoResponders />,
      },
      {
        path: 'account-settings',
        element: <ManageAccount />,
      },
      {
        path: 'account-settings/contacts',
        element: <AccountContacts />,
      },
      {
        path: 'account-settings/contact',
        element: <AccountContact />,
      },
      {
        path: 'account-settings/ip-whitelist',
        element: <IpWhitelist />,
      },
      {
        path: 'account-settings/mfa',
        element: <MfaEnforcement />,
      },
      {
        path: 'ip-whitelist',
        element: <Whitelist />,
      },
      {
        path: 'support',
        element: <Support />,
      },
      {
        path: 'user-settings',
        element: <Settings />,
      },
      {
        path: 'user-settings/profile',
        element: <SettingsProfile />,
      },
      {
        path: 'user-settings/security',
        element: <Security />,
      },
      {
        path: 'user-settings/appearance',
        element: <SettingsAppearance />,
      },
    ],
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/password_reset',
    element: <ResetPasswordPage />,
  },
  {
    path: 'components',
    element: <ComponentsPage />,
  },
  {
    path: '*',
    element: <PageNotFoundPage />,
  },
]);

const App = () => {
  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
};

export default App;
